// /gallery deep link — the surveillance feed now lives in HQ's FEED tab;
// this route stays for old links and renders the same component.
import { el, mount } from "../lib/dom";
import { currentUser } from "../lib/firebase";
import { photoFeed } from "../components/feed";
import { webviewBanner } from "../components/webview-banner";
import { nav } from "../components/nav";

let cleanup: (() => void) | null = null;

export async function renderGallery(): Promise<void> {
  cleanup?.();
  const uid = currentUser()!.uid;
  const feed = photoFeed(uid);
  cleanup = feed.cleanup;
  mount(el("div", {},
    webviewBanner(),
    el("h2", {}, "// SURVEILLANCE FEED"),
    feed.el,
    nav("/hq"),
  ));
}
